(function () {
  function updateSubscriptionBlock() {
    const subscriptionContainer = document.querySelector(
      ".shopify_subscriptions_app_container"
    );

    if (!subscriptionContainer) return;

    const policy = subscriptionContainer.querySelector(
      ".shopify_subscriptions_app_policy"
    );

    const lists = subscriptionContainer.querySelectorAll(".group_list");

    if (policy && lists.length) {
      const lastList = lists[lists.length - 1];

      if (lastList.nextElementSibling !== policy) {
        lastList.insertAdjacentElement("afterend", policy);
      }

      if (policy.textContent.trim() !== "Cancel anytime") {
        policy.textContent = "Cancel anytime";
      }
    }

    lists.forEach((list) => {
      const items = list.querySelectorAll("li");

      if (items.length > 1) return;

      const labels = list.querySelectorAll("label");

      labels.forEach((label) => {
        const textTargets = label.querySelectorAll(
          ".title_and_price_wrapper > span"
        );

        textTargets.forEach((target) => {
          const originalText = target.textContent.trim();
          const cleanText = originalText.split(",")[0].trim();

          if (originalText !== cleanText) {
            target.textContent = cleanText;
          }
        });
      });
    });
  }

  function moveSubscriptionOptionPriceToGroupHeader() {
    const subscriptionContainer = document.querySelector(
      ".shopify_subscriptions_app_container"
    );

    if (!subscriptionContainer) return;

    const subscriptionGroups = subscriptionContainer.querySelectorAll(
      ".subscription_group"
    );

    subscriptionGroups.forEach((group) => {
      const headerWrapper = group.querySelector(
        ":scope > .title_and_price_wrapper"
      );
      const groupList = group.querySelector(":scope > .group_list");

      if (!headerWrapper || !groupList) return;

      const firstOptionPrice = groupList.querySelector("li .in_widget_price");

      if (!firstOptionPrice) return;

      if (firstOptionPrice.parentElement !== headerWrapper) {
        headerWrapper.appendChild(firstOptionPrice);
      }
    });
  }

  function updateSubscriptionComparePrice() {
    const subscriptionContainer = document.querySelector(
      ".shopify_subscriptions_app_container"
    );

    if (!subscriptionContainer) return;

    const groups = subscriptionContainer.querySelectorAll(".subscription_group");

    groups.forEach((group) => {
      const inputs = group.querySelectorAll(
        'input[data-radio-type="selling_plan"][data-variant-compare-at-price]'
      );

      inputs.forEach((input) => {
        const comparePrice = input.getAttribute("data-variant-compare-at-price");

        if (!comparePrice) return;

        const label = input.closest("label");
        if (!label) return;

        const priceElement = group.querySelector(
          ":scope > .title_and_price_wrapper > .in_widget_price"
        ) || label.querySelector(".in_widget_price");

        if (!priceElement) return;

        const existingComparePrice = priceElement.querySelector(
          ".compare-price-subscription"
        );

        if (existingComparePrice) {
          if (existingComparePrice.textContent.trim() !== comparePrice) {
            existingComparePrice.textContent = comparePrice;
          }
          return;
        }

        const currentPrice = priceElement.textContent.trim();

        if (!currentPrice.startsWith(comparePrice)) {
          priceElement.innerHTML = `<span class="compare-price-subscription">${comparePrice}</span> ${currentPrice}`;
        }
      });
    });
  }

  function initSubscriptionUpdates() {
    updateSubscriptionBlock();
    moveSubscriptionOptionPriceToGroupHeader();
    updateSubscriptionComparePrice();

    const subscriptionContainer = document.querySelector(
      ".shopify_subscriptions_app_container"
    );

    if (!subscriptionContainer) return;

    const observer = new MutationObserver(function () {
      updateSubscriptionBlock();
      moveSubscriptionOptionPriceToGroupHeader();
      updateSubscriptionComparePrice();
    });

    observer.observe(subscriptionContainer, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSubscriptionUpdates);
  } else {
    initSubscriptionUpdates();
  }
})();